<template>
<!--
  https://george-hadjigeorgiou97.medium.com/step-by-step-custom-drag-drop-upload-component-in-vuetify-vue-2-43c99794643d
-->
  <v-dialog @click:outside="closeDialog" :value="dialog" max-width="450px">
    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon x-large color="info" :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60" @click.prevent="selectFiles">
            mdi-cloud-upload
          </v-icon>
          <p class="text-h6">
            Trascina qui il file da caricare
            <br>(o clicca l'icona per selezionarlo)
          </p>
        </v-row>
        <v-virtual-scroll
          v-if="uploadedFiles.length > 0"
          :items="uploadedFiles"
          height="100"
          item-height="50"
        >
          <template v-slot:default="{ item }">
            <v-list-item :key="item.name">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <span class="ml-3 text--secondary">
                    {{ item.size }} bytes</span
                  >
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn @click.stop="removeFile(item.name)" icon>
                  <v-icon large> mdi-close-circle </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-card-text>
      <v-card-actions>

        <v-spacer></v-spacer>

        <v-btn @click="closeDialog" icon>
          <v-icon x-large color="info" id="close-button">mdi-close</v-icon>
        </v-btn>       

        <v-tooltip top >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" :disabled="!uploadedFiles.length" icon @click.stop="submit" :loading="loading">
                <v-icon x-large color="success" id="upload-button">mdi-upload</v-icon>
              </v-btn>                  
            </template>
            <span>Carica</span>
        </v-tooltip> 
  
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Upload",

  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dragover: false,
      uploadedFiles: []
    };
  },

  methods: {
    selectFiles() {
      const input = document.createElement('input');
      input.type = 'file';
      input.multiple = this.multiple;
      input.style.display = 'none';
      input.addEventListener('change', (e) => {
        if (e.target && e.target.files) {
          [...e.target.files].forEach((element) => this.uploadedFiles.push(element));
        }
        document.body.removeChild(input);
      });
      console.log(99,this.uploadedFiles);
      document.body.appendChild(input);
      input.click();
    },    
    closeDialog() {
      // Remove all the uploaded files
      this.uploadedFiles = [];
      // Close the dialog box
      this.$emit("update:dialog", false);
    },

    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(
        file => file.name === fileName
      );

      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
    },

    onDrop(e) {
        console.log(103,e);
      this.dragover = false;

      // If there are already uploaded files remove them
      if (this.uploadedFiles.length > 0) this.uploadedFiles = [];
      console.log(108,this.multiple)
      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        this.$store.dispatch("addNotification", {
          message: "E' possibile caricare un solo file alla volta...",
          colour: "error"
        });
      }
      // Add each file to the array of uploaded files
      else
        Array.from(e.dataTransfer.files).forEach(element => this.uploadedFiles.push(element) )
        /*
        e.dataTransfer.files.forEach(element =>
          this.uploadedFiles.push(element)
        );*/
    },

    submit() {
      // If there aren't any files to be uploaded throw error
      if (!this.uploadedFiles.length > 0) {
        this.$store.dispatch("addNotification", {
          message: "Nessun File da caricare",
          colour: "error"
        });
      } else {
        // Send uploaded files to parent component
        console.log(148,this.uploadedFiles)
        this.$emit("filesUploaded", this.uploadedFiles);
        // Close the dialog box
        this.closeDialog();
      }
    }
  }
};
</script>